'use client'

import clsx from 'clsx'

import ActionSectionSimple from './ActionSectionSimple'
import SearchField from '../SearchField/SearchField'

import { Link, usePathname } from '@/i18n/navigation'
import TeqplayLogo from '@/app/images/teqplayLogo/TeqplayLogo'
import { useAnalytics } from '@/app/lib/analytics'
import BackButton from '@/app/components/BackButton/BackButton'

export default function NavbarClient({ isHomepage }: { isHomepage: boolean }) {
  const { trackTeqplayRedirectCTA } = useAnalytics()
  const pathname = usePathname()
  const isVesselDetailPage = /^\/vessels\/[^/]+$/.test(pathname)

  return (
    <nav className={clsx('navbar', { 'no-border': isHomepage })}>
      <div className="navbar-container">
        <div className="navbar__logo">
          <Link
            href="https://teqplay.com"
            target="_blank"
            rel="noopener noreferrer"
            className="logo"
            title="PortCallOne"
            onClick={() =>
              trackTeqplayRedirectCTA({
                source: 'navbar_logo',
                url: 'https://teqplay.com'
              })
            }
          >
            <TeqplayLogo width={30} />
            <span>Teqplay</span>
          </Link>
        </div>
        <ActionSectionSimple />
      </div>
      {isVesselDetailPage && (
        <div className="search-container-mobile">
          <div className="flex items-center gap-2xs">
            <BackButton className="navbar__back-button" />
            <SearchField />
          </div>
        </div>
      )}
    </nav>
  )
}
